/** Hash router: `#/projects`, `#/p/<id>`, `#/p/<id>/tree/<treeId>`, `#/p/<id>/admin`, `#/p/<id>/export`. Pure, so it is unit-tested. */

export type Route =
  | { name: 'projects' }
  | { name: 'project'; id: string }
  | { name: 'tree'; id: string; treeId: string }
  | { name: 'admin'; id: string }
  | { name: 'export'; id: string }
  | { name: 'privacy' };

export function parseHash(hash: string): Route {
  const path = hash.replace(/^#/, '').replace(/^\/+/, '').replace(/\/+$/, '');
  const parts = path.split('/').filter(Boolean).map(decodeURIComponent);
  if (parts.length === 0 || parts[0] === 'projects') return { name: 'projects' };
  if (parts[0] === 'privacy') return { name: 'privacy' };
  if (parts[0] === 'p' && parts[1]) {
    const id = parts[1];
    if (!parts[2]) return { name: 'project', id };
    if (parts[2] === 'tree' && parts[3]) return { name: 'tree', id, treeId: parts[3] };
    if (parts[2] === 'admin') return { name: 'admin', id };
    if (parts[2] === 'export') return { name: 'export', id };
    return { name: 'project', id };
  }
  return { name: 'projects' };
}

export function toHash(route: Route): string {
  switch (route.name) {
    case 'projects':
      return '#/projects';
    case 'privacy':
      return '#/privacy';
    case 'project':
      return `#/p/${encodeURIComponent(route.id)}`;
    case 'tree':
      return `#/p/${encodeURIComponent(route.id)}/tree/${encodeURIComponent(route.treeId)}`;
    case 'admin':
      return `#/p/${encodeURIComponent(route.id)}/admin`;
    case 'export':
      return `#/p/${encodeURIComponent(route.id)}/export`;
  }
}

export function projectIdOf(route: Route): string | null {
  return 'id' in route ? route.id : null;
}
